import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu } from 'antd';
import { topMenuConfig } from '../config/menuConfig';

const { Header, Content, Sider } = AntLayout;

const Layout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const topMenuItems = topMenuConfig.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: item.label,
  }));

  const currentTopKey = '/' + (pathname.split('/').filter(Boolean)[0] || 'shipments');
  const currentConfig = topMenuConfig.find((c) => c.key === currentTopKey);
  const sideItems = currentConfig?.children?.map((child) => ({
    key: child.key,
    label: child.label,
  })) ?? [];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', background: '#001529' }}>
        <div style={{ color: '#fff', marginRight: 24, fontWeight: 600 }}>KFC 凯飞越履行中心</div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[currentTopKey]}
          items={topMenuItems}
          onClick={({ key }) => {
            const config = topMenuConfig.find((c) => c.key === key);
            const firstChild = config?.children?.[0]?.key;
            navigate(firstChild || key);
          }}
          style={{ flex: 1, minWidth: 0 }}
        />
      </Header>
      <AntLayout>
        {sideItems.length > 0 && (
          <Sider width={240} style={{ background: '#fff' }}>
            <Menu
              mode="inline"
              selectedKeys={[pathname]}
              items={sideItems}
              onClick={({ key }) => navigate(key)}
              style={{ height: '100%', borderRight: 0 }}
            />
          </Sider>
        )}
        <Content style={{ padding: 24, background: '#f0f2f5' }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
